/* eslint-disable no-nested-ternary */
import React from 'react';
import { Tooltip } from 'antd';
import moment from 'moment';
import { BarChartOutlined } from '@ant-design/icons';
import { dateFromMongoId } from '@src/utils/mongo-id';

export const COMPETITOR = {
  birthdaybot: {
    img: 'https://avatars.slack-edge.com/2022-09-02/4028655733237_69a8eae2fd9c7ee3b6b9_48.png',
  },
  celebrations: {
    img: 'https://avatars.slack-edge.com/2023-05-17/5307136771632_23fc04d1c85ee699a7ab_48.png',
  },
  celebrations_by_airsp: {
    img: 'https://avatars.slack-edge.com/2023-05-16/5288408943857_dd9163fa2fbd9025ef1a_48.png',
  },
  heytaco: {
    img: 'https://avatars.slack-edge.com/2021-06-07/2144814816035_94f18513ec97458e7bb0_48.png',
  },
  matterbot: {
    img: 'https://avatars.slack-edge.com/2022-11-01/4299030558022_e2a5fae587705849f775_48.png',
  },
  bonusly: {
    img: 'https://avatars.slack-edge.com/2021-10-28/2661929214659_f41700f65ac4e426b25e_48.png',
  },
  shoutouts_by_airspeed: {
    img: 'https://avatars.slack-edge.com/2023-04-13/5127211793904_7088033763605e48a27a_48.png',
  },
  evergreen: {
    img: 'https://avatars.slack-edge.com/2023-05-30/5327792447847_3bb43fe865ece4bcc5e5_48.png',
  },
  engagewith: {
    img: 'https://avatars.slack-edge.com/2023-03-30/5022544196855_a000bed0e301f9f64919_48.jpg',
  },
  kudosing: {
    img: 'https://avatars.slack-edge.com/2021-08-13/2391014510897_40fec22846e73c878042_48.png',
  },
  kudosbot: {
    img: 'https://avatars.slack-edge.com/2023-02-06/4760731044611_ecb27ff0dc6bd0db7a20_48.png',
  },
  culturebot: {
    img: 'https://avatars.slack-edge.com/2022-05-16/3515634159655_6e18d0e2e4fda972f49e_48.png',
  },
  praisely: {
    img: 'https://avatars.slack-edge.com/2023-04-15/5139623395664_0649280d5251b2df33ed_48.png',
  },
  karma: {
    img: 'https://avatars.slack-edge.com/2022-05-27/3589622557075_b34dc94138c453d6c88f_48.png',
  },
  dankon: {
    img: 'https://avatars.slack-edge.com/2023-05-21/5298925769186_018ddd00b8a34f2e09a3_48.jpg',
  },
  imfrank: {
    img: 'https://avatars.slack-edge.com/2023-08-14/5735683573365_570b714f197102e08a1f_48.jpg',
  },
  kudos_by_deel: { img: 'https://avatars.slack-edge.com/2023-08-28/5813816642835_8005c4ff994e070d5c9f_48.png' },
  kudos3: { img: 'https://avatars.slack-edge.com/2023-12-01/6278380443075_dbbca51be8a8a0f9c802_48.png' },
  apprecibot: { img: 'https://avatars.slack-edge.com/2023-10-20/6067627830949_1be8fbc1ad4c65b1d34d_48.png' },
  hoyaapp: { img: 'https://avatars.slack-edge.com/2023-09-21/5924356618406_e0b79e8279dc95e00c08_48.png' },
  donut: { img: 'https://avatars.slack-edge.com/2022-09-09/4060168159219_5a8b151d919e04a8dd33_48.png' },
  lunchroulette: { img: 'https://avatars.slack-edge.com/2021-08-02/2335227334581_969f0b24917e19128476_48.png' },
  coffee_chat: { img: 'https://avatars.slack-edge.com/2023-11-24/6246729434258_4e38df24419204ff597e_48.png' },
  coffeetalk_by_airspee: { img: 'https://avatars.slack-edge.com/2023-07-14/5593172258401_6337014d649325db1660_48.png' },
  randomcoffee: { img: 'https://avatars.slack-edge.com/2022-10-11/4204093575171_db5534cd827feec7181a_48.png' },
  randomcoffees: { img: 'https://avatars.slack-edge.com/2022-02-08/3090082092641_b4b3c5d53252fb154b86_48.png' },
  catchup: { img: 'https://avatars.slack-edge.com/2022-01-07/2921791993586_38c8c8c38c5c6fd60799_48.jpg' },
  spotbot: { img: 'https://avatars.slack-edge.com/2023-01-22/4665258584535_9ee4c129bc9ee8cd88a2_48.jpg' },
  pringa: { img: 'https://avatars.slack-edge.com/2023-08-08/5722632410305_37358b55579ff4f7bce4_48.png' },
  dates_celebration_bot: { img: 'https://avatars.slack-edge.com/2023-10-30/6137171691568_f8490aa6ddfae287ce84_48.png' },
  surveys: { img: 'https://avatars.slack-edge.com/2022-07-26/3847384633893_bb2335a5848131e9b6d5_48.png' },
  surveyapp: { img: 'https://avatars.slack-edge.com/2023-06-07/5374890169447_2f8a296dec1295e15f16_48.png' },
  polly: { img: 'https://avatars.slack-edge.com/2022-05-16/3525831951110_93a5fc5000afac75d4b8_48.png' },
  simplepoll: { img: 'https://avatars.slack-edge.com/2022-08-14/3962301693312_3a4f2a76bb17bbdfc635_48.png' },
  jolly: { img: 'https://avatars.slack-edge.com/2023-12-29/6405256235987_49617a1efdfc9ce38b91_48.png' },
  'pulse-surveys-roots': { img: 'https://avatars.slack-edge.com/2023-01-24/4677485294327_f8ef6368d31167f5f812_48.png' },
  organice: { img: 'https://avatars.slack-edge.com/2023-10-11/6021682488082_e3c06bc95baebaf6c8f7_48.png' },
  'org-chart-deel': { img: 'https://avatars.slack-edge.com/2023-01-24/4694487007124_07888194087b874d310d_48.png' },
  org_by_roots: { img: 'https://avatars.slack-edge.com/2023-01-24/4694487007124_07888194087b874d310d_48.png' },
  cultureamp: { img: 'https://avatars.slack-edge.com/2023-06-01/5363583455620_a6a7e27f32cb29f666e1_48.png' },
  boost: { img: 'https://avatars.slack-edge.com/2023-04-24/5144701752839_26852f2343b83355c60e_48.png' },
  wrenly: { img: 'https://avatars.slack-edge.com/2024-02-12/6612557631447_5971bef20cbe2441845a_48.png' },
  incognito: { img: 'https://avatars.slack-edge.com/2022-10-17/4235766010164_e82cf1feab8f80211df2_48.png' },
  propsy: { img: 'https://avatars.slack-edge.com/2024-05-17/7132950372821_cc21625a16af43b4e772_48.png' },
  shuffl: { img: 'https://avatars.slack-edge.com/2024-06-28/7370246343168_f9a1060906fc363bf3de_48.png' },
  doozy: { img: 'https://avatars.slack-edge.com/2023-03-12/4937397323266_6590843c32254546cdd0_48.png' },
  trivia: { img: 'https://avatars.slack-edge.com/2023-12-13/6340410202181_4663f43d8f82698850b1_48.png' },
  'anonymous-bot': { img: 'https://avatars.slack-edge.com/2022-06-16/3693676174289_2223c97d6b50163298f9_48.png' },
  superpoll: { img: 'https://avatars.slack-edge.com/2023-09-24/5945162556724_d1ef5152ae9d482dc2ae_48.png' },
  advancedpoll: { img: 'https://avatars.slack-edge.com/2024-06-17/7284793315749_394236a6e55f3903b281_48.png' },
  botimum: { img: 'https://avatars.slack-edge.com/2024-01-31/6556094258614_081bade38b724d539c84_48.png' },
  ipoll: { img: 'https://avatars.slack-edge.com/2024-05-22/7145498019063_d08c48549bb644f8b4f0_48.png' },
  justpolls: { img: 'https://avatars.slack-edge.com/2024-06-10/7250968243187_ecd050d7d9f66431c279_48.png' },
  openpoll: { img: 'https://avatars.slack-edge.com/2021-10-14/2608140996484_d38a6c1dd3606c550ffb_48.png' },
  open_poll_plus: { img: 'https://avatars.slack-edge.com/2023-07-31/5662996973075_e89bc6202bc2e54dce08_48.png' },
  quickpoll: { img: 'https://avatars.slack-edge.com/2023-03-15/4956675591813_829cb0be6a1667407d12_48.png' },
  birthday: { img: 'https://avatars.slack-edge.com/2024-07-18/7426974522775_fd001c77156fda778976_48.webp' },
  standuply: { img: 'https://avatars.slack-edge.com/2019-01-24/532266289969_94f65d4b671f62e4379c_48.jpg' },
  troopr: { img: 'https://avatars.slack-edge.com/2024-08-22/7612159166629_275d7f152f69315f6171_48.png' },
  standup_buddy: { img: 'https://avatars.slack-edge.com/2024-08-22/7608407191830_306ee82cf4e47165d378_48.png' },
  alice: { img: 'https://avatars.slack-edge.com/2024-08-22/7615034951570_e81f5a3db19ca93f2a1e_48.png' },
  standup_and_prosper: { img: 'https://avatars.slack-edge.com/2024-08-22/7627700911089_9e49ba87c9a73c148aa5_48.png' },
  sup: { img: 'https://avatars.slack-edge.com/2024-08-22/7612150241861_079b1615725bd4558dde_48.png' },
  dixiapp: { img: 'https://avatars.slack-edge.com/2024-08-22/7608441587318_986333f085a33127e0fb_48.png' },
  standupwizard: { img: 'https://avatars.slack-edge.com/2024-08-22/7600516591975_ce293fcb1edeb17b5c0f_48.jpg' },
  standupbot: { img: 'https://avatars.slack-edge.com/2024-08-22/7614959533715_a645b84c1a847fd1f89d_48.png' },
  geekbot: { img: 'https://avatars.slack-edge.com/2024-08-22/7612184495653_31fdd9b144b54c9c9c3e_48.png' },
  jack: { img: 'https://avatars.slack-edge.com/2024-08-22/7615063477794_4d14a513a32b3ad8ad18_48.png' },
  dailybot: { img: 'https://avatars.slack-edge.com/2022-08-10/3919521809013_bd011826a44e6bb47bd9_48.jpg' },
  mycheckins: { img: 'https://avatars.slack-edge.com/2024-08-22/7600577874023_d12d9bb879b217c23384_48.png' },
  teamoclock: { img: 'https://avatars.slack-edge.com/2024-08-22/7600576543127_240fcdf44270b1ff0b4a_48.png' },
  standbot: { img: 'https://avatars.slack-edge.com/2024-08-22/7615019983043_449238420cf5edd6f495_48.png' },
  gather_ai: { img: 'https://avatars.slack-edge.com/2024-08-22/7615342319458_16ed787692707bef1b5a_48.png' },
  time: { img: 'https://avatars.slack-edge.com/2024-08-22/7617827495956_e3aee6aa464343ddfdc4_48.png' },
  vacationbot: { img: 'https://avatars.slack-edge.com/2022-03-02/3179601458258_95782b5aa52f59b1b700_48.png' },
  flamingo: { img: 'https://avatars.slack-edge.com/2025-05-05/8853102515044_e05e79c783cf6c08ec2c_48.png' },
  spock: { img: 'https://avatars.slack-edge.com/2025-04-02/8694771446245_7022690408401005b390_48.png' },
  simplest_tracker: { img: 'https://avatars.slack-edge.com/2024-04-11/6942167286374_4e3cf70587a3cb8b5da2_48.jpg' },
  attendancebot: { img: 'https://avatars.slack-edge.com/2022-06-15/3671891307138_53b22da83be871c7ca34_48.png' },
  calamari: { img: 'https://avatars.slack-edge.com/2024-12-18/8195861545652_b0b8b84b214406c2ae9b_48.png' },
  remoty_bot: { img: 'https://avatars.slack-edge.com/2023-05-10/5237499441877_ce35b74b2af3a6716e8c_48.png' },
  officebot: { img: 'https://avatars.slack-edge.com/2025-03-13/8584730607079_4589422a8e38dc1d92cf_48.png' },
  timebot: { img: 'https://avatars.slack-edge.com/2018-02-17/316863939829_fe4abf030c7a9a220218_48.jpg' },
  'time-off-deel': { img: 'https://avatars.slack-edge.com/2024-06-24/7324814208290_992cd8e90b00cb8612ae_48.png' },
};

const billyEventDisplay = (key, stats) => (
  <span>
    <Tooltip
      placement="right"
      title={(
        <div>
          <div>{`(${(stats[`${key}Count`] - stats[`${key}OptOutCount`])}/${(stats.usersCount - stats[`${key}OptOutCount`])})`}</div>
          <div>{`${stats[`${key}OptOutCount`]} opt-out`}</div>
        </div>
      )}
    >
      {((stats.usersCount - stats[`${key}OptOutCount`]) === 0) ? '0%' : `${(100 * ((stats[`${key}Count`] - stats[`${key}OptOutCount`]) / (stats.usersCount - stats[`${key}OptOutCount`]))).toFixed(2)}%`}
    </Tooltip>
  </span>
);
const kudosInfo = (w, isSeed = false) => {
  const channelStr = w.channels.map((c) => (
    <div key={c.id}>
      {c.info.is_private ? '🔒' : '#️⃣'}
      {`${c.info.name} - ${c.members.length} 👥`}
    </div>
  ));
  return (
    <div>
      <div>{w.channels.length > 0 ? channelStr : 'No channel'}</div>
      {isSeed && <div>{`Leaderboard: ${w.leaderboard.type} ${w.leaderboard.type !== 'NONE' ? `${w.leaderboard.weeklyUpdate.activated ? `🔔 (${moment().day(w.leaderboard.weeklyUpdate.weekDay).hour(w.leaderboard.weeklyUpdate.hour).format('dddd @ ha')})` : '🔕'}` : ''}`}</div>}
      {!isSeed && <div>{`Leaderboard: ${w.leaderboard.type} ${w.leaderboard.type !== 'NONE' ? `${w.leaderboard.notifications.length > 0 ? `🔔 (${moment().day(w.leaderboard.notifications[0].weekDay).hour(w.leaderboard.notifications[0].hour).format('dddd @ ha')})` : '🔕'}` : ''}`}</div>}
      <div>{`Appreciation Day: ${w.appreciationDay.activated ? `✅ Every ${w.appreciationDay.frequency} week(s) on ${moment().day(w.appreciationDay.weekDay).format('dddd')}` : '❌'}`}</div>
      <br />
      <div>{`Company values (${w.companyValues.length}): ${w.companyValues.map((v) => v.name).join(', ') || '-'}`}</div>
    </div>
  );
};
const kudosColumns = [
  {
    title: '👤 30d',
    render: (w, stats) => (stats ? (
      <>
        {stats.activeUsersCount}
        {' '}
        <a
          href={stats.dashboardLink}
          target="_blank"
          rel="noreferrer"
        >
          <BarChartOutlined />
        </a>
      </>
    ) : ''),
  },
  {
    title: 'Last Activity',
    render: (w, stats) => (stats ? (
      <span
        style={{
          color: stats.latestShoutOutDate && moment(stats.latestShoutOutDate)
            .isBefore(moment()
              .subtract(7, 'days')) ? 'red' : undefined,
        }}
      >
        {stats.latestShoutOutDate
          ? moment(stats.latestShoutOutDate).format('YYYY-MM-DD @ HH:mm')
          : '-'}
      </span>
    ) : ''),
  },
];

const defaultStatus = (w) => ({
  LIVE: '🟢',
  PENDING: '🟠',
  UNINSTALLED: '🔴',
})[w.status === 'LIVE' && !w.installedAt ? 'PENDING' : w.status] || '';

const kudosStatus = (w) => (
  w.status === 'LIVE' && w.channels.length === 0
    ? '🟠'
    : defaultStatus(w)
);

const birthdayInfo = (w) => {
  const hasChannel = w.version >= 'V3' ? w.channels.length > 0 : w.channel;
  const channelStr = w.version >= 'V3'
    ? w.channels.map((c) => (
      <div key={c.id}>
        {c.info.is_private ? '🔒' : '#️⃣'}
        {c.info.name}
        {` (${c.scope.toLowerCase()} - 🔄 ${c.autoCollect ? 'Yes' : 'No'}${c.scope === 'CHANNEL' ? ` - ${c.members.length}` : ''})`}
      </div>
    ))
    : (
      <div>
        {`#${w.channelInfo?.name}`}
      </div>
    );
  return (
    <div>
      {w.version}
      {hasChannel && channelStr}
    </div>
  );
};
const birthdayColumns = [
  {
    title: '🔄',
    render: (w) => (
      w.installedAt
        ? (
          w.version >= 'V3'
            ? (w.channels[0]?.autoCollect ? 'Yes' : 'No')
            : (w.autoCollect ? 'Yes' : 'No')
        )
        : '-'
    ),
  },
  {
    title: 'Stats 🎂',
    render: (w, stats) => (stats ? billyEventDisplay('birthday', stats) : ''),
  },
  {
    title: 'Stats 💼',
    render: (w, stats) => {
      if (!stats) return '';
      const has = (
        w.version >= 'V3'
          ? !!w.channels.find((c) => c.workAnniversary)
          : w.workAnniversary
      );
      if (!has) return '-';
      return billyEventDisplay('workAnniversary', stats);
    },
  },
  {
    title: '#🏆',
    render: (w, stats) => (stats ? stats.celebrationsCount : ''),
  },
  {
    title: '👀💸',
    render: (w) => (typeof w.hasSeenPricing === 'boolean' ? {
      true: 'Yes',
      false: 'No',
    }[w.hasSeenPricing] : '-'),
  },
];

// Mirrors app/modules/services/recurrenceLabel.ts in the API: schedules moved from
// bare {frequency, day, hour} scalars to a structured `recurrence` sub-document
// (weekly, monthly, quarterly, nth-weekday, day-of-month).
const RECURRENCE_LAST = -1;
const MONTHS_PER_QUARTER = 3;
const ORDINAL_SUFFIXES = ['th', 'st', 'nd', 'rd'];

const ordinal = (n) => {
  const mod100 = n % 100;
  // 11th/12th/13th are the exceptions to the 1st/2nd/3rd pattern.
  const suffix = ORDINAL_SUFFIXES[(mod100 - 20) % 10]
    ?? ORDINAL_SUFFIXES[mod100]
    ?? ORDINAL_SUFFIXES[0];
  return `${n}${suffix}`;
};

const recurrenceCadence = ({ freq, interval }) => {
  if (freq === 'WEEKLY') return interval === 1 ? 'Every week' : `Every ${interval} weeks`;
  if (interval === 1) return 'Every month';
  if (interval === MONTHS_PER_QUARTER) return 'Every quarter';
  return `Every ${interval} months`;
};

const recurrenceDayPattern = ({ byWeekday, bySetPos, byMonthDay }) => {
  if (Number.isInteger(byMonthDay)) return `on the ${ordinal(byMonthDay)}`;
  if (!Number.isInteger(byWeekday)) return '';
  // byWeekday uses moment's day indexing (0 = Sunday), same as the API.
  const dayName = moment().day(byWeekday).format('dddd');
  if (!Number.isInteger(bySetPos)) return `on ${dayName}`;
  return bySetPos === RECURRENCE_LAST
    ? `on the last ${dayName}`
    : `on the ${ordinal(bySetPos)} ${dayName}`;
};

const recurrenceLabel = (r) => {
  const time = Number.isInteger(r.hour)
    ? ` at ${moment().hour(r.hour).minute(r.minute || 0).format('h:mma')} (${r.tz || '?'})`
    : '';
  return [recurrenceCadence(r), recurrenceDayPattern(r)].filter(Boolean).join(' ') + time;
};

// Pre-recurrence programs (V1 `matching*` fields, and the short-lived V2 scalars).
const legacyScheduleLabel = (p) => {
  const freq = p.frequency ?? p.matchingFrequency;
  const day = p.day ?? p.matchingDay;
  const hour = p.hour ?? p.matchingHour;
  const dayStr = Number.isInteger(day) ? ` on ${moment().isoWeekday(day).format('dddd')}` : '';
  const hourStr = Number.isInteger(hour) ? ` at ${moment().hour(hour).format('ha')}` : '';
  return `${freq ?? '?'} week(s)${dayStr}${hourStr}`;
};

// V2 audience (IAudience) summary: include/exclude composition (ALL, or nU users /
// mG groups) and Total = resolved computedUserIds.
const audienceRules = (rules = []) => {
  if (rules.some((r) => r.scope === 'ALL')) return 'ALL';
  const u = rules.filter((r) => r.scope === 'USER').length;
  const g = rules.filter((r) => r.scope === 'GROUP').length;
  const parts = [];
  if (u) parts.push(`${u}U`);
  if (g) parts.push(`${g}G`);
  return parts.length ? parts.join(',') : '0';
};
const audienceLabel = (audience) => (
  `Include=${audienceRules(audience.include)} Exclude=${audienceRules(audience.exclude)} Total=${audience.computedUserIds?.length || 0}`
);

export const APP = {
  alfy: {
    version: 2,
    moduleType: 'Connections',
    name: 'Alfy',
    emoji: '☕️',
    slackAppId: 'A0641FFPG80',
    status: (w, stats) => {
      if (!stats && !w.programs) return defaultStatus(w);
      const programs = stats?.programs || w.programs || [];
      return w.status === 'LIVE' && programs.length === 0
        ? '🟠'
        : defaultStatus(w);
    },
    info: (w, stats) => {
      const programs = stats?.programs || w.programs || [];
      return (
        <div>
          {programs.length === 0 && '-'}
          {programs.map((p) => {
            // V2: recurrence sub-document, groupSize, name
            // V1: matchingFrequency/Day/Hour/GroupSize
            const size = p.groupSize ?? p.matchingGroupSize;
            const schedule = p.recurrence
              ? recurrenceLabel(p.recurrence)
              : legacyScheduleLabel(p);
            const audienceSize = new Set(
              (p.audiences || []).flatMap((a) => a.computedUserIds || []),
            ).size;
            const channelsStr = (p.channels || [])
              .map((c) => `${c.info?.is_private ? '🔒' : '#️⃣'}${c.info?.name || '?'} (${(c.members || []).length}👥)`)
              .join(' × ');
            const nameStr = p.name ? `${p.name} - ` : '';
            return (
              <div key={p._id}>
                {`${nameStr}${channelsStr}${channelsStr ? ' - ' : ''}${audienceSize}👥 - 🔄 ${schedule} - x${size}`}
              </div>
            );
          })}
        </div>
      );
    },
    columns: [{
      title: '☕️',
      render: (w, stats) => {
        if (!stats) return null;
        const items = stats.matchingItems || stats.rounds || [];
        if (!items.length) {
          if (!stats.dashboardLink) return '-';
          return (
            <span>
              {'- '}
              <a href={stats.dashboardLink} target="_blank" rel="noreferrer">
                <BarChartOutlined />
              </a>
            </span>
          );
        }
        return (
          <Tooltip
            title={(
              <div>
                {items.map((item) => (
                  <div key={item._id}>
                    {moment(item.date).format('YYYY-MM-DD @ HH:mm')}
                    {` • ${item.users}👤`}
                    {item.hasGroupConversation ? ` • ${item.matchSuccesses}/${item.matches}` : ''}
                  </div>
                ))}
              </div>
            )}
          >
            {`${items.length} `}
            {stats.dashboardLink && (
              <a href={stats.dashboardLink} target="_blank" rel="noreferrer">
                <BarChartOutlined />
              </a>
            )}
          </Tooltip>
        );
      },
    }],
  },
  billy: {
    name: 'Billy',
    emoji: '🎂',
    slackAppId: 'A03UMMBSCH0',
    status: defaultStatus,
    info: birthdayInfo,
    columns: birthdayColumns,
  },
  clappy: {
    version: 2,
    moduleType: 'Recognition',
    name: 'Clappy',
    emoji: '👏',
    slackAppId: 'A06A5FM9ZNX',
    // V2: setupFinishedAt → Module.setupDoneAt (stamped by the first settings save).
    status: (w) => (
      w.status === 'LIVE' && !w.setupDoneAt
        ? '🟠'
        : defaultStatus(w)
    ),
    // V2: V1's channels[] → params.announcements (notification entries),
    // leaderboard.type → showLeaderboardToMembers, appreciationDay.{activated,
    // weekDay, frequency} → appreciationDay.{isEnabled, recurrence}.
    info: (w) => {
      const p = w.params;
      if (!p) return '';
      const { appreciationDay } = p;
      const announcements = p.announcements || [];
      const activeValues = (p.companyValues || []).filter((v) => !v.isArchived);
      return (
        <div>
          <div>
            {announcements.length === 0 && 'No channel'}
            {announcements.map((n) => {
              const info = n.resourceDetails?.info || {};
              return (
                <div key={n._id || n.resourceId}>
                  {`${info.is_private ? '🔒' : '#️⃣'}${info.name || n.resourceId || '?'}`}
                </div>
              );
            })}
          </div>
          {p.audience && <div>{audienceLabel(p.audience)}</div>}
          <div>{`Allowance: ${p.pointsPerPeriod ?? '?'} 👏 / ${(p.pointsPeriodType || '?').toLowerCase()}`}</div>
          <div>{`Leaderboard for members: ${p.showLeaderboardToMembers ? '✅' : '❌'}`}</div>
          <div>
            {`Appreciation Day: ${appreciationDay?.isEnabled && appreciationDay.recurrence
              // The recurrence only picks the day (local midnight); phases carry the hours.
              ? `✅ ${recurrenceLabel({ ...appreciationDay.recurrence, hour: null })}`
              : '❌'}`}
          </div>
          <br />
          <div>{`Company values (${activeValues.length}): ${activeValues.map((v) => v.name).join(', ') || '-'}`}</div>
        </div>
      );
    },
    // V2 stats keep V1's activeUsersCount / latestShoutOutDate keys, so the
    // shared kudos columns render as-is.
    columns: [
      ...kudosColumns,
      {
        title: '#👏',
        render: (w, stats) => (stats ? (
          <Tooltip
            title={(
              <div>
                <div>{`${stats.amplificationsCount ?? 0} amplification(s)`}</div>
                <div>{`${stats.pointsExchanged ?? 0} 👏 exchanged`}</div>
              </div>
            )}
          >
            {stats.shoutOutsCount ?? 0}
          </Tooltip>
        ) : ''),
      },
    ],
  },
  linky: {
    version: 2,
    moduleType: 'Directory',
    name: 'Linky',
    emoji: '🗂️',
    slackAppId: 'A06R8NK1JTF',
    status: (w, stats) => (stats ? (
      w.status === 'LIVE' && stats.isInOrgChartCount === 0
        ? '🟠'
        : defaultStatus(w)
    ) : null),
    info: () => '',
    columns: [
      {
        title: '#️⃣',
        render: (w, stats) => {
          if (!stats) return null;
          if (!stats.isInOrgChartCount) {
            if (!stats.dashboardLink) return '-';
            return (
              <span>
                {'- '}
                <a href={stats.dashboardLink} target="_blank" rel="noreferrer">
                  <BarChartOutlined />
                </a>
              </span>
            );
          }
          return (
            <Tooltip
              title={(
                <div>
                  {`${stats.isInOrgChartCount}/${stats.usersCount}`}
                </div>
              )}
            >
              {`${(100 * (stats.isInOrgChartCount / stats.usersCount)).toFixed(2)}% `}
              {stats.dashboardLink && (
                <a href={stats.dashboardLink} target="_blank" rel="noreferrer">
                  <BarChartOutlined />
                </a>
              )}
            </Tooltip>
          );
        },
      },
    ],
  },
  palmy: {
    version: 2,
    moduleType: 'LeaveManagement',
    name: 'Palmy',
    emoji: '🌴',
    slackAppId: 'A08QSGHK1FS',
    // V2: setupFinishedAt → Module.setupDoneAt (exposed via enrichModules)
    status: (w) => (
      w.status === 'LIVE' && !w.setupDoneAt
        ? '🟠'
        : defaultStatus(w)
    ),
    // V2: scope/scopeUserIds → params.audience (IAudience).
    info: (w) => {
      const audience = w.params?.audience;
      if (!audience) return '';
      return <div>{audienceLabel(audience)}</div>;
    },
    columns: [
      {
        title: '👤 30d',
        // V2 stats keeps the activeUsers30dCount field; omitted when there's no recent activity.
        render: (w, stats) => {
          if (!stats) return null;
          if (!w.setupDoneAt) return '-';
          const count = stats.activeUsers30dCount ?? 0;
          return (
            <span>
              {`${count} `}
              {stats.dashboardLink && (
                <a href={stats.dashboardLink} target="_blank" rel="noreferrer">
                  <BarChartOutlined />
                </a>
              )}
            </span>
          );
        },
      },
    ],
  },
  pulsy: {
    version: 2,
    moduleType: 'Surveys',
    name: 'Pulsy',
    emoji: '🐙',
    slackAppId: 'A0693E57F6V',
    // V2 stats omits surveys/polls when the workspace has none.
    status: (w, stats) => {
      if (!stats) return null;
      const surveys = stats.surveys || [];
      const polls = stats.polls || [];
      return w.status === 'LIVE' && surveys.length === 0 && polls.length === 0
        ? '🟠'
        : defaultStatus(w);
    },
    info: () => '',
    columns: [
      {
        title: '📝',
        render: (w, stats) => {
          if (!stats) return null;
          const surveys = stats.surveys || [];
          if (!surveys.length) return '-';
          return (
            <Tooltip
              title={(
                <div>
                  {surveys.map((survey) => (
                    <div key={survey._id}>
                      {{
                        DRAFT: '📝',
                        SCHEDULED: '⏰',
                        LIVE: '▶️',
                        CLOSED: '🔒',
                      }[survey.status]}
                      {' '}
                      {survey.name}
                      <i>{` (${survey.status.toLowerCase()})`}</i>
                      {survey.frequency ? ` • 🔄 ${survey.frequency}` : ''}
                      {` • ${survey.questions}❓`}
                      {['LIVE', 'CLOSED'].includes(survey.status) && ` • ${survey.responses}/${survey.users}`}
                    </div>
                  ))}
                </div>
              )}
            >
              {`${surveys.filter((s) => s.status !== 'DRAFT').length} / ${surveys.length} `}
              <a
                href={stats.dashboardLink}
                target="_blank"
                rel="noreferrer"
              >
                <BarChartOutlined />
              </a>
            </Tooltip>
          );
        },
      },
      {
        title: '📊',
        render: (w, stats) => {
          if (!stats) return null;
          const polls = stats.polls || [];
          if (!polls.length) return '-';
          return (
            <Tooltip
              title={(
                <div>
                  {polls.map((poll) => (
                    <div key={poll._id}>
                      {moment(dateFromMongoId(poll._id)).format('YYYY-MM-DD')}
                      {poll.frequency ? ` • 🔄 ${poll.frequency}` : ''}
                      {` • ${poll.questions}❓ • ${poll.respondents}🗣️`}
                    </div>
                  ))}
                </div>
              )}
            >
              {polls.length}
            </Tooltip>
          );
        },
      },
    ],
  },
  stany: {
    version: 2,
    moduleType: 'CheckIns',
    name: 'Stany',
    emoji: '📋',
    slackAppId: 'A07FX66V3EJ',
    status: (w, stats) => {
      if (!stats) return defaultStatus(w);
      const standups = stats.standups || [];
      return w.status === 'LIVE' && standups.length === 0
        ? '🟠'
        : defaultStatus(w);
    },
    info: (w, stats) => {
      const standups = stats?.standups || [];
      if (!standups.length) return '-';
      return (
        <div>
          {standups.map((s) => {
            const audienceSize = s.audience?.computedUserIds?.length || 0;
            const days = (s.daysOfWeek || [])
              .map((n) => moment().isoWeekday(n).format('ddd'))
              .join(', ');
            const notifs = (s.notifications || []).map((n) => {
              const p = n.params || {};
              const time = moment()
                .hour(p.hour ?? 0)
                .minute(p.minute ?? 0)
                .format('h:mma');
              if (n.channel === 'CHANNEL') {
                const info = n.resourceDetails?.info || {};
                const prefix = info.is_private ? '🔒' : '#️⃣';
                return `${prefix}${info.name || '?'} @ ${time} (${p.tz || '?'})`;
              }
              const tz = p.timezoneStrategy === 'USER' ? 'user tz' : (p.tz || '?');
              return `DM @ ${time} (${tz})`;
            }).join(' + ');
            const paused = s.pausedUntil ? ' ⏸️' : '';
            return (
              <div key={s._id}>
                {`${s.name} - ${audienceSize}👥 - 🔄 ${days} - ${notifs}${paused}`}
              </div>
            );
          })}
        </div>
      );
    },
    columns: [{
      title: '📊',
      render: (w, stats) => {
        if (!stats) return null;
        const reports = stats.reports || [];
        if (!reports.length) {
          return stats.dashboardLink ? (
            <span>
              {'- '}
              <a href={stats.dashboardLink} target="_blank" rel="noreferrer">
                <BarChartOutlined />
              </a>
            </span>
          ) : '-';
        }
        return (
          <Tooltip
            title={(
              <div>
                {reports.map((r) => (
                  <div key={r._id}>
                    {r.date}
                    {` • ${r.questions}❓ • ${r.updates}/${r.users}🗣️`}
                  </div>
                ))}
              </div>
            )}
          >
            {`${stats.reportsCount} `}
            {stats.dashboardLink && (
              <a href={stats.dashboardLink} target="_blank" rel="noreferrer">
                <BarChartOutlined />
              </a>
            )}
          </Tooltip>
        );
      },
    }],
  },
  seed: {
    name: 'Seed',
    emoji: '🌱',
    slackAppId: 'A05EV5PDY2X',
    status: kudosStatus,
    info: (w) => kudosInfo(w, true),
    columns: [
      ...kudosColumns,
      {
        title: 'Next 🌳',
        render: (w) => w.nextPlantingDate,
      },
    ],
  },
  wishly: {
    name: 'Wishly',
    emoji: '🤖',
    slackAppId: 'A08F2BBTJ10',
    status: defaultStatus,
    info: birthdayInfo,
    columns: birthdayColumns,
  },
  simpleperf: {
    version: 2,
    moduleType: 'PerformanceReviews',
    name: 'SimplePerf',
    emoji: '🎯',
    slackAppId: 'A094CFM1T3L',
    // PerformanceReviews has no audience (Module.params = { tz, emailOptOut }).
    info: () => '',
    // Orange when LIVE but no review cycle has been created yet.
    status: (w, stats) => (
      w.status === 'LIVE' && !(stats && stats.cyclesCount)
        ? '🟠'
        : defaultStatus(w)
    ),
    columns: [
      {
        // cycles / completed reviews (live cycles in tooltip)
        title: '🔄 / ✅',
        render: (w, stats) => {
          if (!stats) return null;
          const cycles = stats.cyclesCount || 0;
          const completed = stats.completedReviewsCount || 0;
          const link = stats.dashboardLink && (
            <a href={stats.dashboardLink} target="_blank" rel="noreferrer">
              <BarChartOutlined />
            </a>
          );
          if (!cycles) {
            return link ? (
              <span>
                {'- '}
                {link}
              </span>
            ) : '-';
          }
          return (
            <Tooltip title={<div>{`${stats.liveCyclesCount || 0} live`}</div>}>
              {`${cycles} / ${completed} `}
              {link}
            </Tooltip>
          );
        },
      },
    ],
  },
};
